import React, { useEffect, useRef } from 'react';
import { QuestionRendererProps } from './types';
import { ColumnArithmetic } from '../ColumnArithmetic';
/**
 * Wrapper around the existing ColumnArithmetic component
 * Adapts it to the QuestionRenderer interface
 */
export function ColumnArithmeticRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  // Track if we've already validated to prevent double-calling
  const hasValidatedRef = useRef(false);
  // Reset validation flag when question changes
  useEffect(() => {
    hasValidatedRef.current = false;
  }, [question.id]);
  // Reset validation flag when shouldValidate becomes false
  useEffect(() => {
    if (!shouldValidate) {
      hasValidatedRef.current = false;
    }
  }, [shouldValidate]);
  const handleComplete = (userAnswer: string) => {
    // Only call onAnswer once per validation
    if (!hasValidatedRef.current) {
      hasValidatedRef.current = true;
      onAnswer(userAnswer);
    }
  };
  return <ColumnArithmetic question={question} onComplete={handleComplete} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-4760" />;
}